import Banner from '../../components/Banner';
import TourismPoints from '../../components/TourismPoints';
// import NextEvents from '../../components/NextEvents';
import FeaturedPoems from '../../components/FeaturedPoems';

import Banner1 from '../../assets/Banner.jpeg';
import Banner2 from '../../assets/Banner2.jpeg';
import Banner3 from '../../assets/Banner3.jpeg';

const images = [
  { src: Banner1, alt: 'Banner 1' },
  { src: Banner2, alt: 'Banner 2' },
  { src: Banner3, alt: 'Banner 3' }
];

export default function Home() {
  return (
    <>
      <Banner 
        images={images} 
        title='São José do Egito' 
        subtitle='Conheça as belezas, eventos e a história da cidade' 
      />
      <TourismPoints />
      {/* <NextEvents /> */}
      <FeaturedPoems />
    </>
  )
}
